// extracted by mini-css-extract-plugin
export default {"container":"CourseFeedSkeletonLoader__container___qjBRK","rightContainer":"CourseFeedSkeletonLoader__rightContainer___Lz0sB"};